import homeService from '../../assets/images/home-services-home.png'
import homeProcess from '../../assets/images/home-process.png'
import webDevelopment from '../../assets/images/home-web-development-image.png'
import gameDevelopment from '../../assets/images/home-game_development.png'
import gameDevelopment1 from '../../assets/images/home-game_development1.png'
import homeUIUX from '../../assets/images/home-ui_ux_image1.png'
import homeUIUX2 from '../../assets/images/home-ui_ux_image2.png'
import MobileSvg from '../../assets/images/mobile'
import NativeApp from '../../assets/images/NativeApp'
import WebSvg from '../../assets/images/web'
import Gamesvg from '../../assets/images/Game'
import UiUxsvg from '../../assets/images/UIUX'
import WebAppSvg from '../../assets/images/WebApp'
import HybridSvg from '../../assets/images/Hybrid'

export default function Service(){
    return (
      <div className="services">
        <div className="container wow fadeInLeft">
          <div className="services-tab">
            <ul className="nav nav-pills row m-0 mb-3" id="pills-tab" role="tablist">
              <li className="nav-item col-md-3 col-6 mb-md-0 mb-4">
                <a className="nav-link active" id="pills-app-development-tab" data-toggle="pill" href="#app-development" role="tab" aria-controls="app-development" aria-selected="true">
              <MobileSvg />
                  <h6>Mobile App Development</h6>
                </a>
              </li>
              <li className="nav-item col-md-3 col-6 mb-md-0 mb-4">
                <a className="nav-link" id="pills-webde-velopment-tab" data-toggle="pill" href="#web-development" role="tab" aria-controls="web-development" aria-selected="false">
                <WebSvg />
                  <h6>Web Development</h6>
                </a>
              </li>
              <li className="nav-item col-md-3 col-6 mb-md-0 mb-4">
                <a className="nav-link" id="pills-game-development-tab" data-toggle="pill" href="#game-development" role="tab" aria-controls="game-development" aria-selected="false">
                <Gamesvg />
                  <h6> Game Development</h6>
                </a>
              </li>
              <li className="nav-item col-md-3 col-6 mb-md-0 mb-4">
                <a className="nav-link" id="pills-design-tab" data-toggle="pill" href="#ui-ux-design" role="tab" aria-controls="design" aria-selected="false">
                <UiUxsvg />
                  <h6>UI/UX Design</h6>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="tab-content" id="pills-tabContent">
          <div className="tab-pane fade show active" id="app-development" role="tabpanel" aria-labelledby="pills-app-development-tab">
         
            <div className="app-development">
              <div className="col-md-6 float-left">
                <div className="app-development-border">
                  <div className="app-development-image">
                  </div>
                  <img src={homeService}/>
                </div>
              </div>
              <div className="col-md-6 float-right development-right">
                <div className="app-development-text wow fadeInRight">
                  <h2>Mobile App<span>Development</span></h2>
                  <p>We at SRP Infotech Offer top of the line mobile development with a highly
                    experienced team.</p>
                </div>
              </div>
            </div>
            <div className="development-services">
              <div className="wow fadeInLeft">
                <div className="services-text">
                  <p>our services</p>
                  <h4>We offer wide</h4>
                  <h4>varieties of it services</h4>
                </div>
              </div>
            </div>
            <div className="services-box row m-0">
              <div className="col-sm-4 float-left">
                <div className="services-app wow swing">
                  <div className="services-box-icon">
                   <NativeApp/>
                  </div>
                  <div className="services-box-text">
                    <h3>Native Application</h3>
                    <p>Native apps are created for one specific platform or operating system.</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-4 float-left">
                <div className="services-app wow swing">
                  <div className="services-box-icon">
                  <WebAppSvg/>
                  </div>
                  <div className="services-box-text">
                    <h3>Web Application</h3>
                    <p>Web apps are responsive versions of websites that can work on any mobile device or OS because
                      they&rsquo;re delivered using a mobile browser.</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-4 float-left">
                <div className="services-app wow swing">
                  <div className="services-box-icon">
                  <HybridSvg/>
                  </div>
                  <div className="services-box-text">
                    <h3>Hybrid Application</h3>
                    <p>Hybrid apps are combinations of both native and web apps, but wrapped within a native app, giving
                      it the ability to have its own icon or be downloaded from an app store.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="development-process row m-0 py-5 my-md-5">
              <div className="col-md-6 float-left">
                <div className="development-process-text wow fadeInLeft">
                  <span>App Development process</span>
                  <h2>How we do?</h2>
                  <p>We follow an agile software development pattern for digital product development. Here are the steps
                    we follow:</p>
                  <p>Analyze <span>-&gt;</span> Design &amp; Develop <span>-&gt;</span> Test <span>-&gt;</span> Feedback
                    <span>-&gt;</span> Update <span>-&gt;</span> Deploy
                  </p>
                  <p>Our team follows each and every step with enthusiasm and passion. We write clean, robust, well
                    structured, and well-documented code. The only thing that matters the most to us is Never
                    compromise with the quality of the product.</p>
                </div>
              </div>
              <div className="col-md-6 float-right">
                <div className="development-process-border  wow fadeInRight position-relative">
                  <div className="development-process-image float-right">
                    <img src={homeProcess}/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="tab-pane fade" id="web-development" role="tabpanel" aria-labelledby="pills-webde-velopment-tab">
            <div className="web-development">
              <div className="col-md-6 float-left web-development-img wow fadeInLeft position-relative">
                <div className="web-development-image">
                  <img src={webDevelopment}/>
                </div>
              </div>
              <div className="col-md-6  development-text float-left">
                <div className="web-development-text">
                  <div className="web-development-box">
                    <span className="web-development-title wow fadeInRight">Web development</span>
                    <h2 className="wow fadeInRight">Business <span>Website</span>  &amp; Development</h2>
                    <p className="wow fadeInRight">Expert Web developers team willtransform your great ideas
                      toworkable web solution.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="our-specialities">
              <div className="our-specialities-text">
                <h4 className="wow bounceIn">Our Specialities</h4>
                <span className="wow bounceIn">Good design heaven everywhere</span>
                <p className="wow bounceIn">We at SRP Infotech offer top of the line E-commerce Website Design with a highly
                  experienced team</p>
              </div>
            </div>

            <div className="web-development-services clearfix">
              <div className="container">
                <div className="web-development-services-border"></div>
                <div className="web-development-services-image">
                  <div className="graphics-design col-md-3 position-relative">
                    <p className="services-number">01</p>
                    <div className="web-development-services-icon">
                      {/* <xml version="1.0" encoding="utf-8"/>
                      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewbox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <style type="text/css">
                       
                        </style>
                        <g>
                          <path className="st0" d="M447.2,66.6h-6.1c11.6-18.9,7.3-44.2-11.3-58c-20-14.9-48.5-10.1-62.5,10.8l-31.5,47.1h-271
                      c-22.3,0-40.4,18.1-40.4,40.4v258.3c0,22.3,18.1,40.4,40.4,40.4h156.9l-11.9,49.8h-25.6c-16.7,0-30.2,13.6-30.2,30.2v6.3h-31.5
                      c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10h267c5.5,0,10-4.5,10-10c0-5.5-4.5-10-10-10H358v-6.3c0-16.7-13.6-30.2-30.2-30.2h-25.6
                      l-11.9-49.8h156.9c22.3,0,40.4-18.1,40.4-40.4v-56.8V107C487.6,84.7,469.4,66.6,447.2,66.6L447.2,66.6z M303.9,242.4
                      c-15.6,10.9-44.9-3.9-72.9,11c-6.8-35.5-2.5-68.8,33-76.2c4.6-1,9.5-1.4,13.7-1.3c12,8.9,24.2,17.9,36.2,26.8
                      C319.2,218,317.2,233.1,303.9,242.4L303.9,242.4z M314,135.2l28.3,21l-21.8,26.5c-9-6.6-16.7-12.4-25.6-19
                      C296.7,160.9,312.3,137.7,314,135.2z M384,30.6c7.6-11.3,23-14,33.9-5.9c10.9,8.1,12.9,23.6,4.2,34.2
                      c-15.3,18.7-51.8,63.1-67.1,81.9l-29.9-22.2L384,30.6z M338,485.7v6.3H174v-6.3c0-5.6,4.6-10.2,10.2-10.2h143.4
                      C333.4,475.4,338,480,338,485.7L338,485.7z M281.6,455.4h-51.1l11.9-49.8h27.4L281.6,455.4z M467.6,365.2
                      c0,11.2-9.1,20.4-20.4,20.4c-15.9,0-364.5,0-382.3,0c-11.2,0-20.4-9.1-20.4-20.4v-46.8H73c5.5,0,10-4.5,10-10c0-5.5-4.5-10-10-10
                      H44.4V107c0-11.2,9.1-20.4,20.4-20.4h257.6c-9.6,14.3-37.5,56.1-46.4,69.3c-19.6,0.2-39.2,7-52,22c-17.4,20.3-20.5,52.3-9.1,95
                      c1.9,7.3,11.1,9.9,16.6,4.7c25.9-24.7,58.1,2.2,86.9-21.1c17.6-14.2,21.8-36.9,15.1-58.1c9-10.9,82.7-100.8,91.7-111.7h21.9
                      c11.2,0,20.4,9.1,20.4,20.4v191.4H153c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10h314.6L467.6,365.2z"></path>
                          <path className="st0" d="M111.1,298.6c-4.8,1-8,5.1-8,9.8c0,6.3,5.7,11,11.9,9.8c5.5-1.1,8.9-6.5,7.8-11.8
                      C121.7,301,116.4,297.5,111.1,298.6L111.1,298.6z"></path>
                        </g>
                      </svg> */}
                    </div>
                    <div className="web-development-services-text">
                      <h3>Graphics Design</h3>
                      <p>We are a team of dedicated UI UX Designer who believes in building world-className design for your
                        web and mobile application. </p>
                    </div>
                  </div>
                  <div className="ecommerce-development col-md-3">
                    <p className="services-number">02</p>
                    <div className="web-development-services-icon">
                      {/* <xml version="1.0" encoding="utf-8"/>
                      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewbox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <style type="text/css">
                        
                        </style>
                        <path className="st0" d="M467,101h-88.8v-3.7c0-14.8-12-26.9-26.9-26.9H314V32.8C314,14.7,299.3,0,281.2,0h-50.4
                  C212.7,0,198,14.7,198,32.8v37.7h-37.4c-14.8,0-26.9,12.1-26.9,26.9v3.7H45c-24.8,0-45,20.2-45,45v231c0,24.8,20.2,45,45,45h149.6
                  l-13.2,60h-60.5c-8.3,0-15,6.7-15,15s6.7,15,15,15h270.3c8.3,0,15-6.7,15-15s-6.7-15-15-15h-60.5l-13.2-60H467c24.8,0,45-20.2,45-45
                  V146C512,121.2,491.8,101,467,101L467,101z M228,32.8c0-1.5,1.2-2.8,2.8-2.8h50.4c1.5,0,2.8,1.2,2.8,2.8v37.7h-56V32.8z M163.8,101
                  v-0.5H198v20.1c0,19.3,30,20.5,30,0V101v-0.5h56v0.5v19.6c0,20.6,30,19.2,30,0c0-7.7,0-12.5,0-20.1h34.2v0.5v160.2H163.8
                  C163.8,257.7,163.8,104.1,163.8,101L163.8,101z M212.1,482l13.2-60h61.4l13.2,60H212.1z M482,377c0,8.3-6.7,15-15,15
                  c-17.7,0-402.6,0-422,0c-8.3,0-15-6.7-15-15v-22.3h452V377z M482,324.7H30V146c0-8.3,6.7-15,15-15h88.8v133.3
                  c0,14.8,12.1,26.9,26.9,26.9h190.7c14.8,0,26.9-12,26.9-26.9V131H467c8.3,0,15,6.7,15,15L482,324.7z"></path>
                      </svg> */}
                    </div>
                    <div className="web-development-services-text">
                      <h3>E-commerce Development</h3>
                      <p>We are expert in what it takes to generate conversions for a shopping website. We deliver
                        focused and experienced professional eCommerce web design solutions for B2B and B2C businesses.
                      </p>
                    </div>
                  </div>
                  <div className="digital-marketing col-md-3">
                    <p className="services-number">03</p>
                    <div className="web-development-services-icon">
                      {/* <xml version="1.0" encoding="utf-8"/>
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewbox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                    
                        <path className="st0" d="M89.9,511.5H10c-5.5,0-10-4.5-10-10V345.7c0-5.5,4.5-10,10-10h79.9c5.5,0,10,4.5,10,10v155.8
                  C99.9,507,95.4,511.5,89.9,511.5z M20,491.5h59.9V355.7H20V491.5z"></path>
                        <path className="st0" d="M227.1,512h-79.9c-5.5,0-10-4.5-10-10V286.2c0-5.5,4.5-10,10-10h79.9c5.5,0,10,4.5,10,10V502
                  C237.1,507.5,232.6,512,227.1,512z M157.2,492h59.9V296.2h-59.9V492z"></path>
                        <path className="st0" d="M364.3,511.5h-79.9c-5.5,0-10-4.5-10-10V189.8c0-5.5,4.5-10,10-10h79.9c5.5,0,10,4.5,10,10v100.2
                  c0,5.5-4.5,10-10,10c-5.5,0-10-4.5-10-10v-90.2h-59.9v291.7h59.9V373.3c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10v128.2
                  C374.3,507,369.8,511.5,364.3,511.5z"></path>
                        <path className="st0" d="M364.3,344c-2.6,0-5.2-1.1-7.1-2.9c-1.9-1.9-2.9-4.4-2.9-7.1c0-2.6,1.1-5.2,2.9-7.1c1.9-1.9,4.4-2.9,7.1-2.9
                  c2.6,0,5.2,1.1,7.1,2.9c1.9,1.9,2.9,4.4,2.9,7.1c0,2.6-1.1,5.2-2.9,7.1C369.5,342.9,366.9,344,364.3,344z"></path>
                        <path className="st0" d="M501.5,511.5h-79.9c-5.5,0-10-4.5-10-10V127.9c0-5.5,4.5-10,10-10h79.9c5.5,0,10,4.5,10,10v373.6
                  C511.5,507,507,511.5,501.5,511.5z M431.6,491.5h59.9V137.9h-59.9V491.5z"></path>
                        <path className="st0" d="M49.9,190.2c-4.4,0-8.5-3-9.7-7.4c-1.4-5.3,1.8-10.8,7.1-12.2c2-0.5,207-55.3,409.2-169.2
                  c4.8-2.7,10.9-1,13.6,3.8c2.7,4.8,1,10.9-3.8,13.6C359.5,78.9,252.8,122.2,182,147.9c-76.7,27.9-129,41.8-129.5,41.9
                  C51.6,190,50.8,190.2,49.9,190.2z"></path>
                        <path className="st0" d="M449.7,46.6c-1.4,0-2.7-0.3-4.1-0.9c-5-2.2-7.3-8.1-5.1-13.2l5.6-12.5h-14.3c-5.5,0-10-4.5-10-10
                  c0-5.5,4.5-10,10-10h29.6c3.4,0,6.5,1.7,8.4,4.5c1.8,2.8,2.1,6.4,0.8,9.5l-11.8,26.6C457.2,44.3,453.6,46.6,449.7,46.6z"></path>
                      </svg> */}
                    </div>
                    <div className="web-development-services-text">
                      <h3>Digital Marketing</h3>
                      <p>Recognized as a top Digital Marketing company in India, Proceed Innovative combines proven
                        optimization techniques with breakthrough marketing solutions. </p>
                    </div>
                  </div>
                  <div className="app-development-services col-md-3">
                    <p className="services-number">04</p>
                    <div className="web-development-services-icon">
                      {/* <?xml version="1.0" encoding="utf-8"?> */}
                      {/* <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewbox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <style type="text/css">
                          .st0 {
                            fill: #70B4C6;
                            stroke: #70B4C6;
                            stroke-width: 0.25;
                            stroke-miterlimit: 10;
                          }
                        </style> */}
                        {/* <g>
                          <path className="st0" d="M360,8H152c-17.7,0-32,14.3-32,32v432c0,17.7,14.3,32,32,32h208c17.7,0,32-14.3,32-32V40
                    C392,22.3,377.7,8,360,8z M293.4,24l-4.5,16h-66.7l-4-16H293.4z M376,472c0,8.8-7.2,16-16,16H152c-8.8,0-16-7.2-16-16V40
                    c0-8.8,7.2-16,16-16h49.8l6.5,25.9c0.9,3.6,4.1,6.1,7.8,6.1h79c3.6,0,6.7-2.4,7.7-5.8l7.4-26.2H360c8.8,0,16,7.2,16,16V472z"></path>
                          <path className="st0" d="M229,443h-56c-4.4,0-8,3.6-8,8s3.6,8,8,8h56c4.4,0,8-3.6,8-8S233.4,443,229,443z"></path>
                          <path className="st0" d="M266,443h-8c-4.4,0-8,3.6-8,8s3.6,8,8,8h8c4.4,0,8-3.6,8-8S270.4,443,266,443z"></path>
                          <path className="st0" d="M284.1,209.1c-3.8-2.3-8.7-1-11,2.7l0,0l-48,80c-2.3,3.8-1,8.7,2.7,11c3.8,2.3,8.7,1,11-2.7l0,0l48-80
                    C289.1,216.3,287.9,211.4,284.1,209.1L284.1,209.1z"></path>
                          <path className="st0" d="M310.2,211c-2.8-3.5-7.8-4-11.2-1.2c-3.5,2.8-4,7.8-1.2,11.2l28,35l-28,35c-2.8,3.5-2.2,8.5,1.2,11.2
                    c3.5,2.8,8.5,2.2,11.2-1.2l32-40c2.3-2.9,2.3-7.1,0-10L310.2,211z"></path>
                          <path className="st0" d="M201.8,301c2.8,3.5,7.8,4,11.2,1.2c3.5-2.8,4-7.8,1.2-11.2l-28-35l28-35c2.8-3.5,2.2-8.5-1.2-11.2
                    c-3.5-2.8-8.5-2.2-11.2,1.2l-32,40c-2.3,2.9-2.3,7.1,0,10L201.8,301z"></path>
                        </g>
                      </svg> */}
                    </div>
                    <div className="web-development-services-text">
                      <h3>App Development</h3>
                      <p>Our mobile app developers with expertise in developing outstanding mobile apps for iphone and
                        android will help you to convert your vision into reality.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="tab-pane fade" id="game-development" role="tabpanel" aria-labelledby="pills-game-development-tab">
            <div className="game-development">
              <div className="game-development-services1 row">
                <div className="col-md-6 float-left">
                  <div className="game-development-services1-image wow fadeInLeft position-relative">
                    <img src={gameDevelopment}/>
                  </div>
                </div>
                <div className="col-md-6 float-left">
                  <div className="game-development-services1-text float-md-right wow fadeInRight">
                    <h5>game development</h5>
                    <h2><span>Effective</span> &amp; <br></br> more strategy</h2>
                    <p>The art of creating games and <br></br>describes the design, development &amp;<br></br> release of a game</p>
                  </div>
                </div>
              </div>

              <div className="game-development-services2 row m-0 px-3">
                <div className="col-md-6 float-left">
                  <div className="game-development-services2-text wow fadeInLeft">
                    <h2><span>Optimize</span> the performance  of your <span>Games</span></h2>
                    <p>We are Making Games Infrastructures<br></br> with stunning graphics and user interface<br></br> for
                      Smart-Phones.</p>
                  </div>
                </div>
                <div className="col-md-6 float-left wow fadeInRight">
                  <div className="game-development-services-border"></div>
                  <div className="game-development-services2-image">
                    <img src={gameDevelopment1}/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="tab-pane fade" id="ui-ux-design" role="tabpanel" aria-labelledby="pills-design-tab">
            <div className="ui-ux-design">
              <div className="ui-ux-design-services">
                <div className="col-md-6 float-left">
                  <div className="ui-ux-design-services-text wow fadeInLeft">
                    <h5>Graphics Designer</h5>
                    <h2>UI/UX Design with <span>Wireframes</span></h2>
                    <p>We offer dynamic and interactive UI/UX <br></br> development services using the latest tools and <br></br>
                      
                      technologies.</p>
                  </div>
                </div>
                <div className="col-md-6 float-left ui-ux-design-left-img position-relative" >
                  <div className="ui-ux-design-services-image float-right wow fadeInRight">
                    <img src={homeUIUX}/>
                    <div className="experience">
                      <h1>5+</h1>
                      <p>Years<br></br> of Experience</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="ui-ux-design-box">
                <div className="ui-ux-design-box-innere row m-0" style={{width : '100vw'}}>
                  <div className="col-md-7 float-left wow fadeInLeft">
                    <div className="ui-ux-design-border"></div>
                    <div className="ui-ux-design-image">
                      <img src={homeUIUX2}/>
                    </div>
                  </div>
                  <div className="col-md-3 float-left px-md-0 px-4 pe-5">
                    <div className="ui-ux-design-text float-right wow fadeInRight">
                      <h2>Our Build  <span>Serivces</span> for  Developers</h2>
                      <ul>
                        <li>Meet the users&rsquo; needs</li>
                        <li>Have a clear hierarchy</li>
                        <li>Keep it consistent</li>
                        <li>Narrative design</li>
                        <li>Design with personality</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}